// Packages
import React from "react"
import PropTypes from "prop-types"

// Styles
import "./ToolTip.scss"

function ToolTip(props) {
  const { tooltipText } = props

  return (
    <div className="ToolTip">
      <span className="tooltip-text">{tooltipText}</span>
    </div>
  )
}

ToolTip.propTypes = {
  tooltipText: PropTypes.string.isRequired,
}

export default ToolTip
